// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b3ca5034","455":"cd69d732","977":"fd2ff397"}[chunkId] + ".chunk.js";
};